import { Text } from "@reverb-ui/react";

export type TRangePanelInfoProps = {
  rangeValue?: string;
}

export const RangePanelInfo = ({rangeValue} : TRangePanelInfoProps ) : JSX.Element => {
  return (
    <Text fontSize="xl" alignSelf={"flex-end"} py={1}>
      ({rangeValue})
    </Text>
  );
};